import React from "react";

export const Heading = (Props) => {
  return (
    <div className="textclr">
      <h4>{Props.heading}</h4>
    </div>
  );
};
